import { connect } from 'react-redux';

import addAbilityToOpenModal from '../../../../utilities/modalHOC';
import CardRow from './CardRow';

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default addAbilityToOpenModal(
  connect(mapStateToProps, mapDispatchToProps)(CardRow),
);
